module.exports = __webpack_public_path__ + "fe1b60fc.svg";